module.exports = __webpack_public_path__ + "img/icon-copy-link.7383d29f.svg";